// src/components/About/index.js
import React, { Component } from 'react';
import {Link} from 'react-router';

import FlatButton from 'material-ui/FlatButton';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import Avatar from 'material-ui/Avatar';
import { browserHistory } from 'react-router';

import auth from '../service/auth';

export default class AdminHeader extends Component {
  state = {
    userUpdated: null
  }

  constructor(props) {
    super(props);
    auth.addListener(this.userChanged.bind(this));
  }

  userChanged(user) {
    this.setState({userUpdated: new Date()});
  }

  logout() {
    auth.logout().then(() => {
      browserHistory.push('/login');
    })
  }

  logoItem() {
    return <img src="/logo.png" key="Logo" style={{height: "40px", width: "auto", marginLeft: "20px"}}></img>
  }

  frontPageLink(title) {
    return <Link to="/" key="FrontPageLink">
              <FlatButton label={title} primary={this.props.selected == "companies"} style={{marginLeft:'2px', marginRight:'2px'}}/>
            </Link>;
  }

  nameSearchLink() {
    return <Link to="/namesearch" key="NameSearchLink">
              <FlatButton label="Nimihaku" primary={this.props.selected == "namesearch"} style={{marginLeft:'2px', marginRight:'2px'}}/>
            </Link>;
  }

  categoriesLink() {
    return  <Link to="/categories" key="CategoriesLink">
                <FlatButton label="Toimialat"  primary={this.props.selected == "categories"} style={{marginLeft:'2px', marginRight:'2px'}}/>
            </Link>
  }

  industriesLink() {
    return  <Link to="/industries" key="IndustriesLink">
                <FlatButton label="Toimialat"  primary={this.props.selected == "industries"} style={{marginLeft:'2px', marginRight:'2px'}}/>
            </Link>
  }

  usersLink() {
    return <Link to="/users" key="UsersLink">
      <FlatButton label="Käyttäjät"  primary={this.props.selected == "users"} style={{marginLeft:'2px', marginRight:'2px'}} />
    </Link>;
  }

  unpublishedLink() {
    return <Link to="/unpublished" key="UnpublishedLink">
    <FlatButton label="Julkaisemattomat"  primary={this.props.selected == "unpublished"} style={{marginLeft:'2px', marginRight:'2px'}} />
  </Link>;
  }

  render() {
    var user = auth.currentUser();
    var userData = auth.userData;

    if (auth.currentUser() != null) {
      var menuItems = [];

      if (userData && userData.isAdmin) {
        menuItems = [this.frontPageLink("Yrityshaku"), this.unpublishedLink(), this.nameSearchLink(), this.industriesLink(), this.usersLink()];
      } else {
        menuItems = [this.frontPageLink("Omat asiakkaat"), this.nameSearchLink()];
      }

      return (
        <Toolbar style={{backgroundColor: 'white', borderBottom: '1px rgba(232, 232, 232, 1) solid'}}>
          <ToolbarGroup>
            {menuItems}
          </ToolbarGroup>
          <ToolbarGroup>
            <Avatar src={user.photoURL}></Avatar>
            <FlatButton label="Kirjaudu ulos" onTouchTap={() => this.logout()} style={{marginLeft:'2px', marginRight:'2px'}} />
          </ToolbarGroup>
        </Toolbar>
      );
    } else {
      return (
        <Toolbar>

        </Toolbar>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/AdminHeader.js